export default __webpack_public_path__ + "static/media/HindiDiwas5.9e214ecd.JPG";